<template>
  <v-card class="card-container">
    <div class="main-toolbar mb-4">
      <div class="icon-back">
        <v-icon color="white" size="28">mdi-android-studio</v-icon>
      </div>

      <span class="main-toolbar-title"> Calibração </span>
    </div>

    <div class="hidden-md-and-up">
      <v-tabs
        :height="40"
        :mobile-break-point="300"
        v-model="tab"
        class="ma-auto"
        icons-and-text
      >
        <v-tabs-slider color="#BBCF20"></v-tabs-slider>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-tab
              active-class="activated-tab"
              class="rounded-lg rounded-b-0"
              v-on="on"
              v-bind="attrs"
              :value="0"
            >
              <v-icon>mdi-decagram</v-icon>
            </v-tab>
          </template>
          <span>{{ $t('Certificados') }}</span>
        </v-tooltip>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-tab
              v-if="institution.userType != 5"
              active-class="activated-tab"
              class="rounded-lg rounded-b-0"
              v-on="on"
              v-bind="attrs"
              :value="1"
            >
              <v-icon>mdi-cog</v-icon>
            </v-tab>
          </template>
          <span>{{ $t('Padrão') }}</span>
        </v-tooltip>
        <v-tab
          v-if="institution.userType != 5"
          :value="2"
          active-class="activated-tab"
          class="rounded-lg rounded-b-0"
        >
          {{ $t('Template') }}
          <v-icon class="mt-1 mr-2">mdi-folder-open-outline</v-icon>
        </v-tab>
        <v-tab
          :value="3"
          active-class="activated-tab"
          class="rounded-lg rounded-b-0"
        >
          {{ $t('Certificados Legado') }}
          <v-icon class="mt-1 mr-2">mdi-file-document-outline</v-icon>
        </v-tab>
      </v-tabs>
    </div>

    <div class="hidden-sm-and-down">
      <v-tabs :height="40" v-model="tab" icons-and-text>
        <v-tabs-slider color="#BBCF20"></v-tabs-slider>
        <v-tab
          :value="0"
          active-class="activated-tab"
          class="rounded-lg rounded-b-0"
        >
          {{ $t('Certificados') }}
          <v-icon class="mt-1 mr-2">mdi-decagram</v-icon>
        </v-tab>
        <v-tab
          v-if="institution.userType != 5"
          :value="1"
          active-class="activated-tab"
          class="rounded-lg rounded-b-0"
        >
          {{ $t('Padrão') }}
          <v-icon class="mt-1 mr-2">mdi-cog</v-icon>
        </v-tab>
        <v-tab
          v-if="institution.userType != 5"
          :value="2"
          active-class="activated-tab"
          class="rounded-lg rounded-b-0"
        >
          {{ $t('Template') }}
          <v-icon class="mt-1 mr-2">mdi-folder-open-outline</v-icon>
        </v-tab>
        <v-tab
          :value="institution.userType != 5 ? 3 : 1"
          active-class="activated-tab"
          class="rounded-lg rounded-b-0"
        >
          {{ $t('Certificados (Antigo)') }}
          <v-icon class="mt-1 mr-2">mdi-file-document-outline</v-icon>
        </v-tab>
      </v-tabs>
    </div>
    <v-tabs-items v-model="tab">
      <v-tab-item :value="0">
        <v-card flat class="mt-0">
          <CertifiedTab />
        </v-card>
      </v-tab-item>
      <v-tab-item v-if="institution.userType != 5" :value="1">
        <v-card flat class="mt-0">
          <PatternTab />
        </v-card>
      </v-tab-item>
      <v-tab-item v-if="institution.userType != 5" :value="2">
        <v-card flat class="mt-0">
          <TemplateTab />
        </v-card>
      </v-tab-item>
      <v-tab-item :value="institution.userType != 5 ? 3 : 1">
        <v-card flat class="mt-0">
          <LegacyCertificates />
        </v-card>
      </v-tab-item>
    </v-tabs-items>
  </v-card>
</template>

<script>
import CertifiedTab from './components/certified/tab.vue'
import PatternTab from './components/pattern/tab.vue'
import TemplateTab from './components/template/tab.vue'
import LegacyCertificates from './components/legacyCalibration/CalibrationCetifiedTable/CalibrationCertifiedTable.vue'

export default {
  name: 'CalibrationV2',

  components: {
    CertifiedTab,
    PatternTab,
    TemplateTab,
    LegacyCertificates,
  },

  data() {
    return {
      tab: null,
      institution: {},
    }
  },

  created() {
    this.institution = JSON.parse(localStorage.getItem('institution'))

    console.log(this.$route.query)
    if (this.$route.query.tab != null)
      this.tab = parseInt(this.$route.query.tab)

    console.log(this.tab)
  },
}
</script>

<style scoped>
.v-tabs--icons-and-text > .v-tabs-bar .v-tab {
  flex-direction: row-reverse;
}

.v-tab.v-tab {
  color: #bbcf20;
}

.v-tab {
  text-transform: none;
}

.v-tab--active {
  background-color: #e7eaeb;
}
</style>
